import api from './api';

/**
 * Notificações de menção do CRM, compartilhadas por toda a sessão.
 *
 * A origem da verdade é o REST (`/mention-notifications`). Aqui a atualização
 * é por polling; se um dia a Star tiver websocket (Reverb/Pusher), basta
 * assinar o canal e chamar `refreshNotifications()` a cada evento — o resto
 * do fluxo não muda.
 */

const RETRY_DELAY = 30000;
const POLL_INTERVAL = 60000;

let state = { notifications: [], unreadCount: 0 };
let started = false;
let retryTimer = null;
let pollTimer = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(state));

const setState = (next) => {
    state = next;
    notify();
};

const fetchNotifications = () =>
    api.get('/mention-notifications')
        .then((res) => setState({
            notifications: res.data.resources ?? [],
            unreadCount: res.data.unread_count ?? 0,
        }))
        .catch(() => {
            clearTimeout(retryTimer);
            retryTimer = setTimeout(fetchNotifications, RETRY_DELAY);
        });

const start = () => {
    if (started) return;
    started = true;

    fetchNotifications();

    clearInterval(pollTimer);
    pollTimer = setInterval(fetchNotifications, POLL_INTERVAL);
};

export const getNotifications = () => state;

// Formato subscribe/getSnapshot esperado por useSyncExternalStore.
export const subscribeNotifications = (listener) => {
    start();
    listeners.add(listener);
    listener(state);
    return () => {
        listeners.delete(listener);
    };
};

// Re-busca imediata após uma ação local (marcar como lida).
export const refreshNotifications = () => fetchNotifications();

export const resetNotifications = () => {
    clearTimeout(retryTimer);
    clearInterval(pollTimer);
    retryTimer = null;
    pollTimer = null;
    started = false;
    setState({ notifications: [], unreadCount: 0 });
};
